// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__ic1Xo","calendarButtons":"ClockData_calendarButtons__2E-2V"};